export default "__VITE_ASSET__DsM80YUE__"